const FILTER_BUTTON_SELECTOR = '[data-collection-page-filter]';
const LISTING_SELECTOR = '[data-collection-page-listing]';
const ROW_SELECTOR = '.collection-page__row';
const ROWS_SELECTOR = '.collection-page__rows';
const ACTIVE_CLASS = 'is-active';
const HIDDEN_CLASS = 'is-hidden';
const REVERSED_CLASS = 'is-reversed';

let collectionPageFiltersBound = false;

function getListing(element) {
    return element.closest(LISTING_SELECTOR);
}

function applyFilter(listing, filterId) {
    const rowsContainer = listing.querySelector(ROWS_SELECTOR);
    if (!rowsContainer) {
        return;
    }

    const rows = rowsContainer.querySelectorAll(ROW_SELECTOR);
    rows.forEach((row) => {
        const rowFilterIds = (row.dataset.filterIds || row.dataset.filterId || '')
            .split(/[\s,]+/)
            .filter(Boolean);
        const isMatch = !filterId || rowFilterIds.includes(filterId);
        row.classList.toggle(HIDDEN_CLASS, !isMatch);
    });

    updateRowLayout(rowsContainer);
}

function updateRowLayout(rowsContainer) {
    const isOneRow = rowsContainer.classList.contains('one-row');
    const rows = rowsContainer.querySelectorAll(ROW_SELECTOR);
    let visibleIndex = 0;

    rows.forEach((row) => {
        const isHidden = row.classList.contains(HIDDEN_CLASS);
        const isReversed = isOneRow && !isHidden && visibleIndex % 2 === 1;
        row.classList.toggle(REVERSED_CLASS, isReversed);
        if (!isHidden) {
            visibleIndex += 1;
        }
    });
}

function setActiveButton(listing, selectedButton) {
    listing.querySelectorAll(FILTER_BUTTON_SELECTOR).forEach((button) => {
        const isActive = button === selectedButton;
        button.classList.toggle(ACTIVE_CLASS, isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
}

function onFilterClick(event) {
    const button = event.target.closest(FILTER_BUTTON_SELECTOR);
    if (!button) {
        return;
    }

    const listing = getListing(button);
    if (!listing) {
        return;
    }

    setActiveButton(listing, button);
    applyFilter(listing, button.dataset.collectionPageFilter || '');
}

export function initCollectionPageFilters() {
    if (collectionPageFiltersBound) {
        return;
    }

    collectionPageFiltersBound = true;
    document.addEventListener('click', onFilterClick);
}
